module.exports = __webpack_public_path__ + "img/smbp_150x150.87e5d0f1.png";